<template>
  <b-container
    fluid
  />
</template>
<script>
import { core } from '@/config/pluginInit'

export default {
  name: 'AuditDashboard',

  middleware: ['auth', 'audit'],

  metaInfo () {
    return {
      title: 'Dashboard'
    }
  },

  mounted () {
    core.index()
  }
}
</script>
